import React, { useCallback, useState } from 'react';
import TilesToolbar from 'widgets/tiles/components/toolbar/TilesToolbar';
import { DragAndDropProvider } from '@instinet-analytics/semantic-ui-components';
import './CapsulesContainer.scss';

import { CapsulesContainer } from './CapsulesContainer';
import AddCapsuleDropdown from 'widgets/tiles/components/AddCapsuleDropdown/AddCapsuleDropdown';

export default function CapsuleContainerWidget() {
    const [addPanelVisible, setAddPanelVisible] = useState(false);

    const toggleAddPanelVisibility = useCallback(() => {
        setAddPanelVisible(!addPanelVisible);
    }, [addPanelVisible, setAddPanelVisible]);

    return (
        <div className="TilesWidget">
            <TilesToolbar toggleAddPanelVisibility={toggleAddPanelVisibility} />
            {addPanelVisible && (
                <AddCapsuleDropdown dismiss={toggleAddPanelVisibility} />
            )}
            <DragAndDropProvider bacDragAndDropProvider>
                <CapsulesContainer
                    openAddCapsulePanel={toggleAddPanelVisibility}
                />
            </DragAndDropProvider>
        </div>
    );
}
